// Company users — the selection list (GET /company-users/users/selection) that
// feeds pickers like the unit drawer's "Add person". Static per session; no
// cache tags needed.

import { baseApi } from '../baseApi';
import { ROUTES } from '../routes';

export interface UserOption {
  id: string;
  name: string;
  email?: string;
}

interface ApiUserOption {
  _id: string;
  fullName: string;
  email?: string | null;
}

// The envelope is unwrapped by axiosBaseQuery, so the response here is
// `{ items: [...] }` — accept a bare array too, defensively.
type ApiUsersSelection = { items?: ApiUserOption[] } | ApiUserOption[];

export const usersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUsersSelection: build.query<UserOption[], void>({
      query: () => ({ ...ROUTES.companyUsers.selection }),
      transformResponse: (res: ApiUsersSelection) => {
        const items = Array.isArray(res) ? res : (res?.items ?? []);
        return items.map((u) => ({ id: u._id, name: u.fullName, email: u.email ?? undefined }));
      },
    }),
  }),
});

export const { useGetUsersSelectionQuery } = usersApi;
